import React from 'react';

import PropTypes from 'prop-types';
import styled from 'styled-components';

import { Button, SvgComponent } from '@quikr/ui';
import vipBenefitsSprite from '@quikr/ui/src/assets/vip-benefits-sprite.svg';

const Table = styled.table`
  &,
  th,
  td {
    border: 1px solid ${({ theme }) => theme.colors.Neutral[200]};
    border-collapse: collapse;
  }
  th,
  td {
    padding: 12px;
  }
  th.basic,
  th.vip {
    color: white;
  }
  th.benefits {
    background: #72ce8a;
  }
  th.basic {
    background: #9facc6;
  }
  th.vip {
    background: ${({ theme }) => theme.colors.Primary};
  }
  .check {
    transform: rotate(135deg) scale(1.5, 1.5);
  }
  @media screen and (min-width: 768px) {
    th,
    td {
      padding: 8px;
    }
    .xdN {
      display: none;
    }
  }
`;

const PayButton = styled(Button)`
  background: ${({ theme }) => theme.colors.Primary};
  height: 35px;
`;

const Svgicon = styled(SvgComponent)`
  width: 20px;
  height: 20px;
  margin: 2px 3px 0 0;
`;

const getVIPContent = price => [
  {
    icon: 'apply',
    benefit: 'Number of ads candidate can apply',
    basic: '30 per month',
    vip: 'Unlimited'
  },
  {
    icon: 'track',
    benefit: 'Track applications',
    basic: <span>&#10005;</span>,
    vip: <span className="dIB check fwN">&#172;</span>
  },
  { icon: 'alerts', benefit: 'New job alerts on WhatsApp', basic: '0', vip: 'Unlimited' },
  {
    icon: 'top',
    benefit: 'Profile shown on top to recruiter',
    basic: <span>&#10005;</span>,
    vip: <span className="dIB check fwN">&#172;</span>
  },
  { icon: 'contact', benefit: 'View recruiter contact number', basic: '3', vip: 'Unlimited' },
  { icon: 'validity', benefit: 'Validity of pack', basic: 'NA', vip: '1 month' },
  { icon: 'price', benefit: 'Price', basic: 'Free', vip: `₹${price}` }
];

const VIPTable = ({ price, handleSubmit, loading }) => {
  return (
    <Table className="w100">
      <colgroup>
        <col />
        <col width="30%" />
        <col width="30%" />
      </colgroup>
      <thead>
        <tr className="bt1">
          <th className="benefits fwM">
            Benefits<span className="xdN"> of VIP Packs</span>
          </th>
          <th className="basic fwM">Basic</th>
          <th className="vip fwM">VIP Candidate</th>
        </tr>
      </thead>
      <tbody>
        {getVIPContent(price).map((benefitTuple, idx) => {
          return (
            <tr key={idx}>
              <td className="bt2">
                <div className="dF">
                  <Svgicon className="fs0" svgSprite={vipBenefitsSprite} id={benefitTuple.icon} />
                  {benefitTuple.benefit}
                </div>
              </td>
              <td className="taC bt1 fwM">{benefitTuple.basic}</td>
              <td className="taC bt1 fwM">{benefitTuple.vip}</td>
            </tr>
          );
        })}
        <tr>
          <td></td>
          <td></td>
          <td className="taC">
            <PayButton
              onClick={handleSubmit}
              btnType="primary"
              size="sm"
              type="button"
              loading={loading}
              disabled={loading}
            >
              Pay ₹{price}
            </PayButton>
          </td>
        </tr>
      </tbody>
    </Table>
  );
};

VIPTable.propTypes = {
  price: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  handleSubmit: PropTypes.func,
  loading: PropTypes.bool
};

export default VIPTable;
